import { render, staticRenderFns } from "./CardOfferedItem.vue?vue&type=template&id=5528366a&scoped=true&"
import script from "./CardOfferedItem.vue?vue&type=script&lang=js&"
export * from "./CardOfferedItem.vue?vue&type=script&lang=js&"
import style0 from "./CardOfferedItem.vue?vue&type=style&index=0&id=5528366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528366a",
  null
  
)

export default component.exports